/** @jsx jsx */
import { forwardRef, type ForwardedRef } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Link, type LinkProps } from '@atlassian/react-resource-router';

function IssueKeyLink(props: LinkProps, ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement>) {
	return <Link ref={ref} {...props} css={issueKeyLinkStyles} />;
}

const issueKeyLinkStyles = css({
	color: token('color.text.subtle'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		color: token('color.text.subtle'),
	},
	fontWeight: token('font.weight.regular'),
	paddingRight: token('space.150', '12px'),
});

export const IssueKey = forwardRef(IssueKeyLink);
